import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';

import LayoutStore from '../../store/Layout';

import { config } from '../../config/index';

import placeholderImage from '../../assets/images/placeholder.jpg';
import Navbar from './Navbar';
import Sidebar from './Sidebar';

import {
  ADMIN_ONLY,
  ALL,
  NO_CLIENT,
  SUPERADMIN_ONLY,
} from '../../helpers/auth';
const { SERVER_URL } = config;

const Layout = ({ user, type, style, children }) => {
  // Get the current URL
  const currentUrlPath = window.location.pathname;
  const access = JSON.parse(localStorage.getItem('access'));
  const [dropdownActive, setDropdownActive] = useState({
    user: false,
    reward: false,
    claim: false,
  });
  const [key, setKey] = useState(0);
  const adminSidebarItems = [
    {
      title: 'Dashboard',
      link: '/live-dashboard',
      menu_auth: true,
      icon: 'fa-solid fa-chart-line',
    },
    {
      title: 'User Management',
      auth: NO_CLIENT,
      children: [
        { title: 'Admin Management', link: '/admins', auth: SUPERADMIN_ONLY },
        { title: 'Client Management', link: '/clients', auth: SUPERADMIN_ONLY },
        {
          title: 'Associate Management',
          link: '/associates',
          auth: ADMIN_ONLY,
        },
      ],
      icon: 'fa-regular fa-user',
    },

    {
      title: 'Smart Scheduler',
      link: '/smart-scheduler',
      menu_auth: access.enable_smart_scheduler,
      icon: 'far fa-calendar-check',
    },
    {
      title: 'Claims',
      link: '/claims',
      menu_auth: access.enable_claims,
      icon: 'far fa-heart',
      children: [
        { title: 'For Approval', link: '/claims/approval', auth: ADMIN_ONLY },
        { title: 'All', link: '/claims', auth: ADMIN_ONLY },
      ],
    },
    {
      title: 'Leave',
      link: '/leaves',
      menu_auth: access.enable_leave_credits,
      icon: 'far fa-calendar-plus',
      children: [
        { title: 'For Approval', link: '/leaves/approval', auth: ADMIN_ONLY },
        { title: 'All', link: '/leaves', auth: ADMIN_ONLY },
      ],
    },
    {
      title: 'Performance Management',
      link: '/performance-management',
      menu_auth: access.enable_performance_management,
      icon: 'fa-tasks',
    },
    {
      title: 'Communication',
      link: '/communication',
      menu_auth: access.enable_communication,
      icon: 'far fa-comments',
    },
    {
      title: 'Trouble Ticketing (TT)',
      link: '/trouble-ticketing',
      menu_auth: access.enable_trouble_ticketing,
      icon: 'fa-laptop',
    },
    {
      title: 'Catalogue',
      link: '/catalogue',
      menu_auth: access.enable_catalogue,
      icon: 'fa-regular fa-images',
    },
    {
      title: 'Delivery Order',
      link: '/delivery-order',
      menu_auth: access.enable_delivery_order,
      icon: 'fa-regular fa-chart-bar',
    },
    {
      title: 'Rewards',
      menu_auth: access.enable_reward,
      children: [
        {
          title: 'Item Management',
          link: '/rewards',
          auth: ADMIN_ONLY,
        },
        {
          title: 'Collection Management',
          link: '/rewards/collections',
          auth: ADMIN_ONLY,
        },
      ],
      icon: 'fa-regular fa-star',
    },
    {
      title: 'Events',
      link: '/events',
      menu_auth: access.enable_event,
      icon: 'fa-regular fa-calendar-days',
    },
    {
      title: 'eDocs',
      link: '/edocs',
      menu_auth: access.enable_edocs,
      icon: 'fa-regular fa-paste',
    },
    {
      title: 'Documents',
      link: '/esign_document',
      menu_auth: access.enable_esign_doc,
      icon: 'fa-folder-open-o',
    },
    {
      title: 'Settings',
      link: '/setting',
      auth: ADMIN_ONLY,
      icon: 'fa-solid fa-list-check',
    },
  ];

  const clientSidebarItems = [
    {
      title: 'Dashboard',
      link: '/live-dashboard',
      menu_auth: true,
      icon: 'fa-solid fa-chart-line',
    },
    {
      title: 'Claims',
      link: '/claims',
      menu_auth: access.enable_claims,
      icon: 'far fa-heart',
      children: [
        { title: 'For Approval', link: '/claims/approval', auth: ALL },
        { title: 'All', link: '/claims', auth: ALL },
      ],
    },
    {
      title: 'Leave',
      link: '/leaves',
      menu_auth: access.enable_leave_credits,
      icon: 'far fa-calendar-plus',
      children: [
        { title: 'For Approval', link: '/leaves/approval', auth: ALL },
        { title: 'All', link: '/leaves', auth: ALL },
      ],
    },
    { title: 'Settings', link: '/setting', menu_auth: true, icon: 'fa-gears' },
  ];

  React.useEffect(() => {
    forceUpdate();
  }, [currentUrlPath]);

  const forceUpdate = () => {
    setKey((prevKey) => prevKey + 1);
  };

  return (
    <LayoutStore>
      <div className="d-flex" style={{ minHeight: '100vh' }}>
        <Sidebar
          key={key}
          type={type}
          items={
            user.type === 'client' ? clientSidebarItems : adminSidebarItems
          }
          currentUrlPath={currentUrlPath}
          setDropdownActive={setDropdownActive}
          dropdownActive={dropdownActive}
        />
        <div className="flex-grow-1" style={{ backgroundColor: '#FAFAFA' }}>
          <Navbar
            img={user.image ? `${SERVER_URL}/${user.image}` : placeholderImage}
            name={user.name ? user.name : user.first_name}
          />
          <main style={style}>{children}</main>
        </div>
      </div>
    </LayoutStore>
  );
};

export default withRouter(Layout);
